import { render, staticRenderFns } from "./bitacora-componente.vue?vue&type=template&id=342a5aa6"
import script from "./bitacora-componente.vue?vue&type=script&lang=js"
export * from "./bitacora-componente.vue?vue&type=script&lang=js"
import style0 from "./bitacora-componente.vue?vue&type=style&index=0&id=342a5aa6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports